import { getIconByKeyword } from "@/components/AccommodationModalDetailed/getIconByKeyword.ts";

export const AmenityTag = ({ name, iconSize = 14 }: { name: string; iconSize?: number }) => {
  const Icon = getIconByKeyword(name);

  return (
    <span className="c-amenity-tag">
      <Icon size={iconSize} />
      <span>{name}</span>
    </span>
  );
};
